import { EuiBetaBadge } from "@inscopix/ideas-eui";

export const ToolBetaBadge = () => {
  return <EuiBetaBadge label="Beta" size="s" color="subdued" />;
};
